import { Hero } from "../components/Hero";
import { AboutIndia } from "../components/AboutIndia";
import { Treatments } from "../components/Treatments";
import { WhyChooseUs } from "../components/WhyChooseUs";
import { OurServices } from "../components/OurServices";
import { PatientJourney } from "../components/PatientJourney";
import { Testimonials } from "../components/Testimonials";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";

import { useNavigate } from "react-router-dom";
import { useSEO } from "../hooks/useSEO";
import { seoContent } from "../data/seoContent";

import { Reveal } from "../components/ui/reveal";

export const HomePage = () => {
    const navigate = useNavigate();

    // Set SEO metadata
    useSEO({
        title: seoContent.homepage.title,
        description: seoContent.homepage.description,
        keywords: seoContent.homepage.keywords,
        canonical: "https://bharatheal.com/"
    });

    const scrollToContact = () => {
        navigate('/contact');
    };

    const goToFreeConsultation = () => {
        navigate('/free-consultation');
    };

    return (
        <>
            <Header onContactClick={scrollToContact} />
            <main className="overflow-hidden">
                <Hero
                    onGetConsultation={goToFreeConsultation}
                    onBookAppointment={scrollToContact}
                />

                <Reveal delay={200} direction="up" duration={1000}>
                    <AboutIndia />
                </Reveal>

                <Reveal delay={200} direction="up" duration={1000} className="bg-gray-50/50">
                    <Treatments onBookConsultation={goToFreeConsultation} />
                </Reveal>

                <Reveal delay={200} direction="up" duration={1000}>
                    <WhyChooseUs />
                </Reveal>



                <Reveal delay={200} direction="up" duration={1000}>
                    <PatientJourney />
                </Reveal>

                <Reveal delay={200} direction="up" duration={1000}>
                    <Testimonials />
                </Reveal>

                <Reveal delay={200} direction="up" duration={1000}>
                    <Contact />
                </Reveal>
            </main>
            <Footer />
        </>
    );
};